// extracted by mini-css-extract-plugin
export default {"chatContainer":"ChatPage_chatContainer__Wgsdk","innerContainer":"ChatPage_innerContainer__lQZCT"};